import { createRoot } from 'react-dom/client';

import App from './App';

import './index.css';

document.getElementById('prerendered-color-guide')?.remove();

createRoot(document.getElementById('root')!).render(<App />);
